export function FlagTH({ size = 22 }) {
  return (
    <svg width={size} height={size * 2 / 3} viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg">
      <rect width="900" height="600" fill="#A51931"/>
      <rect width="900" height="400" y="100" fill="#F4F5F8"/>
      <rect width="900" height="200" y="200" fill="#2D2A4A"/>
    </svg>
  );
}

export function FlagUS({ size = 22 }) {
  return (
    <svg width={size} height={size * 2 / 3} viewBox="0 0 190 100" xmlns="http://www.w3.org/2000/svg">
      <rect width="190" height="100" fill="#B22234"/>
      {[1,3,5,7,9,11].map(i => (
        <rect key={i} x="0" y={i * 100/13} width="190" height={100/13} fill="#FFFFFF"/>
      ))}
      <rect width="76" height={100*7/13} fill="#3C3B6E"/>
      {/* stars simplified as dots */}
      {Array.from({length:50}).map((_,i) => {
        const col = i % 6 === 0 || (Math.floor(i/6) % 2 === 0 && i % 6 < 5) ? 1 : 0;
        const row = Math.floor(i / 6);
        return <circle key={i} cx={6 + (i%6)*12 + (row%2===1?6:0)} cy={5 + row*10} r="2" fill="#fff"/>;
      })}
    </svg>
  );
}
